export default function TodoContainer(){
    return (
        <div>
            <h2>Number of cakes</h2>
            <button>BUY CAKE</button>
        </div>
    )
}